import React from 'react';
import clsx from 'clsx';
import IconCancel from '@/assets/icons/icon-cancel.svg?react';
import IconArrowLeft from '@/assets/icons/icon-arrow-left.svg?react';
import IconDragAndDropVertical from '@/assets/icons/icon-drag-drop-vertical.svg?react';
import { PrimaryButton } from '@/components/buttons/PrimaryButton/PrimaryButton';
import { IconSimpleButton } from '@/components/buttons/IconSimpleButton/IconSimpleButton';

interface PanelTopHeaderProps {
  text: string;
  className: string;
  backButton: boolean;
  onClickBtnBack?: () => void;
  onClickClose?: () => void;
  saveBtnState?: 'default' | 'disabled' | 'loading';
  saveBtnShow?: boolean;
  onSaveClick?: () => void;
  saveBtnText?: string;
  'data-qa-selector-back'?: string;
  'data-qa-selector-save'?: string;
  'data-qa-selector-close'?: string;
}

export const PanelTopHeader: React.FC<PanelTopHeaderProps> = ({
  className,
  onClickBtnBack,
  onClickClose,
  text = 'Sections',
  backButton,
  saveBtnState = 'disabled',
  saveBtnShow = false,
  onSaveClick,
  saveBtnText = 'Save',
  'data-qa-selector-back': dataQaSelectorBack,
  'data-qa-selector-save': dataQaSelectorSave,
  'data-qa-selector-close': dataQaSelectorClose,
}) => {
  return (
    <div
      className={clsx(
        'bg-neutral-0 flex h-13 w-full max-w-[280px] items-center justify-between rounded-t-lg border-b border-neutral-100 px-6 pr-5 pl-3',
        className,
      )}
    >
      <div className="flex items-center gap-1">
        <IconDragAndDropVertical className="assets-drag-handle relative h-5 w-5 cursor-pointer overflow-hidden text-neutral-500" />
        {backButton && (
          <>
            <div className="h-6 w-[1px] bg-neutral-100"></div>
            <button
              className="inline-flex cursor-pointer items-center justify-center gap-2.5 overflow-hidden rounded-md p-[3px] transition-all hover:bg-neutral-100"
              onClick={onClickBtnBack}
              data-qa-selector={dataQaSelectorBack}
            >
              <IconArrowLeft className="relative h-4 w-4 overflow-hidden text-neutral-500" />
            </button>
          </>
        )}
        <span className="text-sm leading-tight font-semibold text-neutral-900">{text}</span>
      </div>
      <div className="flex items-center gap-2">
        {saveBtnShow && (
          <PrimaryButton
            icon={null}
            size="sm"
            onClick={onSaveClick}
            state={saveBtnState}
            text={saveBtnText}
            data-qa-selector={dataQaSelectorSave}
          />
        )}
        <IconSimpleButton
          icon={IconCancel}
          onClick={onClickClose}
          size={24}
          state="default"
          data-qa-selector={dataQaSelectorClose}
        />
      </div>
    </div>
  );
};
